var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-con",on:{"click":_vm.toHome}},[_c('Tooltip',{attrs:{"content":"首页","placement":"bottom"}},[_c('Icon',{attrs:{"type":"ios-home","size":21}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }